import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { CommandStatus, CommandType } from "./types/command.types";
import { TicketPriority, TicketStatus } from "./types/ticket.types";

i18n.use(initReactI18next).init({
	debug: false,
	fallbackLng: "fr",
	interpolation: {
		escapeValue: false, // NOTE: React does escape by default.
	},
	resources: {
		en: {
			translation: {
				ups: {
					status: {
						AR: "Arrived at Facility.",
						DA: "Your package is on the way.",
						DP: "Departed from Facility.",
						DS: "Processing at UPS Facility.",
						MP: "Shipper created a label, UPS has not received the package yet.",
						OF: "Out For Delivery.",
						OR: "Arrived at Facility.",
						PU: "Pickup Scan.",
						RZ: "Your package is pending release from a Government Agency. Once they release it, your package will be on its way.",
					},
				},
			},
		},
		fr: {
			translation: {
				admin: "Admin",
				center_admin: "Admin",
				member: "Membre",
				center_member: "Membre",
				center_user: "Membre",
				audioprosthesist: "Audioprothésiste",
				assistant: "Assistant",
				other: "Autre",
				halted: "En pause",
				command: {
					status: {
						[CommandStatus.ABORTED]: "Annulée",
						[CommandStatus.DELIVERED]: "Livrée",
						[CommandStatus.DRAFT]: "Brouillon",
						[CommandStatus.IN_DELIVERY]: "Expédiée",
						[CommandStatus.MODELING]: "En modélisation",
						[CommandStatus.PRINTING]: "En impression",
						[CommandStatus.POLISHING]: "En finition",
						[CommandStatus.QUALITY_CONTROL]: "En contrôle qualité",
						[CommandStatus.PENDING]: "En pause",
						[CommandStatus.INJECTING]: "En injection silicone",
						[CommandStatus.READY_FOR_DELIVERY]: "Prête à livrer",
						[CommandStatus.RECEIVED]: "Réceptionnée",
						[CommandStatus.WAITING_FOR_RECEPTION]: "En attente de réception",
						HALTED: "En pause",
					},
					type: {
						[CommandType.THREED]: "3D",
						[CommandType.OTOSCAN]: "Otoscan",
						[CommandType.POSTE]: "Poste",
						[CommandType.REWORK]: "Refonte",
						[CommandType.SUPPLY]: "Fourniture",
					},
				},
				ticket: {
					status: {
						[TicketStatus.NEW]: "Nouveau",
						[TicketStatus.OPEN]: "Ouvert",
						[TicketStatus.CLOSED]: "Fermé",
						[TicketStatus.BLOCKED]: "En attente d'éléments",
					},
					priority: {
						null: "Normale",
						[TicketPriority.LOW]: "Normale",
						[TicketPriority.MEDIUM]: "Moyenne",
						[TicketPriority.HIGH]: "Haute",
					},
				},
				ups: {
					status: {
						AR: "Arrivé au dépot UPS.",
						BB: "UPS a fait une demande d'information à l'expéditeur.",
						DA: "Paquet en cours de livraison.",
						DP: "Départ du dépôt UPS.",
						DS: "En cours de traitement au dépôt UPS.",
						MP: "Une étiquette a été créé.",
						OF: "En cours de livraison.",
						OR: "Arrivé au dépot UPS.",
						OT: "En cours de livraison aujourd'hui.",
						PU: "Récupéré par UPS.",
						RZ: "Votre colis est en attente de libération par un service gouvernemental.",
						"9E": "Livré.",
						undefined: "En cours de traitement...",
					},
				},
				supply: {
					status: {
						DRAFT: "Brouillon",
						INACTIVE: "Inactif",
						ACTIVE: "Actif",
					},
				},
				product: {
					status: {
						DRAFT: "Brouillon",
						INACTIVE: "Inactif",
						ACTIVE: "Actif",
					},
				},
				input: {
					select: {
						center: {
							placeholder: "Centre",
						},
					},
				},
				activity_log: {
					type: {
						NEW_COMMAND: "Nouvelle commande",
					},
				},
				new_command: "Nouvelle commande",
				"3d": "3D",
				otoscan: "Otoscan",
				rework: "Refonte",
				poste: "Empreinte physique",
				"no command to export": "Pas de commande à exporter",
				renew: "Renouvellement",
				change_earmold_type: "Changement de type d'embouts",
				change_caracteristics: "Changement de caractéristiques",
				broken: "Casse",
				lost: "Perte",
			},
		},
	},
});

export default i18n;
